module.exports = __webpack_public_path__ + "img/solar_play-broken.0a2d260e.svg";